import { ChangeDetectorRef, Component, ComponentRef, ViewChild } from '@angular/core';

import { BasePortalHost, ComponentPortal, TemplatePortal } from '../../core/core.module';
import { PortalHostDirective } from '../../core/portal/portal-directives';

@Component({
  selector: 'rt-notifications-container',
  template: ` <ng-template portalHost></ng-template> `,
  styleUrls: ['./notifications-container.component.less'],
  standalone: true,
  imports: [PortalHostDirective],
})
export class NotificationsContainerComponent extends BasePortalHost {
  private static LIMIT: Number = 2;

  @ViewChild(PortalHostDirective, { static: true }) public _portalHost: PortalHostDirective;

  private savedComponentRefs: Map<string, ComponentRef<any>> = new Map();

  private activeNotificationReferenceList: Array<ComponentRef<any>> = [];

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  public attachTemplatePortal(portal: TemplatePortal): Map<string, any> {
    return this._portalHost.attachTemplatePortal(portal, 0);
  }

  public attachComponentPortal<T>(
    portal: ComponentPortal<T>,
    index: number = 0,
    groupIdentifier?: string,
  ): ComponentRef<T> {
    const componentRef = this._portalHost.attachComponentPortal(portal, index);
    this.savedComponentRefs.set(groupIdentifier!, componentRef);
    this.activeNotificationReferenceList.push(componentRef);

    componentRef.onDestroy(() => {
      this.savedComponentRefs.delete(groupIdentifier!);
    });

    return componentRef;
  }

  public menageNotificationNumber() {
    if (this.activeNotificationReferenceList.length > NotificationsContainerComponent.LIMIT) {
      const [first, second, ...rest] = this.activeNotificationReferenceList;

      if (first.componentType.name === 'AutomatedActionsAssistantComponent') {
        second.hostView.destroy();
        this.activeNotificationReferenceList = [first, ...rest];
      } else {
        first.hostView.destroy();
        this.activeNotificationReferenceList = [second, ...rest];
      }
    }
  }

  public remove(groupIdentifier: string) {
    if (this.savedComponentRefs.get(groupIdentifier)) {
      this.savedComponentRefs.get(groupIdentifier)!.hostView.destroy();
      this.savedComponentRefs.delete(groupIdentifier);
    }
  }

  public refresh(): void {
    this.cdRef.detectChanges();
  }
}
